import { resolveActionPropertyByWireKey } from './actionPropertyResolver.js';
import { parseRuntimePropertyValue } from './propertyValueCodec.js';

const PROPERTY_COMMAND = /^p(\d+)b(\d+)\.([^=]+)=([\s\S]*)$/;

export function parseSetObjectPropertyCommand(command, resolveTarget) {
    const match = command?.match(PROPERTY_COMMAND);
    if (!match) return null;
    const pageId = Number(match[1]);
    const objectId = Number(match[2]);
    const property = resolveActionPropertyByWireKey(resolveTarget?.(pageId, objectId), match[3]);
    if (!property) return null;
    const value = parseRuntimePropertyValue(match[4], property.metadata);
    if (value === null) return null;
    return {
        type: 'setObjectProperty',
        target: { pageId, objectId },
        property: { ...property.property },
        value,
    };
}
